












































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { Button, Header, CustomLink, Subheader, Container, Logo, Divider, Recaptcha } from '../atoms/'
import { PasswordInputGroup, EmailInputGroup, RegisterTermsAndCondition, SocialLoginBox } from '../molecules'
import { required, sameAs, minLength, email } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { REGISTER_MODULE, REGISTER, EMAIL_SERVER_ERROR, RESET_EMAIL_ERROR } from '../../store/modules/register/constant'
import { AUTH_MODULE, REQUEST_SOCIAL_LOGIN } from '../../store/modules/auth/constant'
import { userWithEmailExist } from '../../utils/errors'
import { EMAIL_FIELD_LIMIT, PASSWORD_FIELD_LIMIT } from '../../utils/field-length'
import { passwordPattern } from '../../utils/validators'
import { SocialLoginPayload } from '../../store/api/type'
import { APP_MODULE, TRANSLATE, DISABLED_SOCIAL } from '../../store/modules/app/constant'
import translate from '@/language'

@Component({
  components: {
    Button,
    Container,
    Header,
    CustomLink,
    Subheader,
    SocialLoginBox,
    PasswordInputGroup,
    EmailInputGroup,
    Logo,
    Divider,
    RegisterTermsAndCondition,
    Recaptcha
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(8),
      passwordPattern
    },
    repeatPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  computed: {
    ...mapGetters(REGISTER_MODULE, [EMAIL_SERVER_ERROR]),
    ...mapGetters(APP_MODULE, [TRANSLATE, DISABLED_SOCIAL])
  },
  methods: {
    ...mapActions(REGISTER_MODULE, [RESET_EMAIL_ERROR, REGISTER]),
    ...mapActions(AUTH_MODULE, [REQUEST_SOCIAL_LOGIN])
  }
})
export default class Register extends Vue {
  private email?: string = ''
  private password?: string = ''
  private repeatPassword?: string = ''
  private recaptchaVisible?: boolean = false
  private isSubmitting: boolean = false

  @Watch('email')
  onEmailChange() {
    this.$v.email.$touch()
    return (this as any)[RESET_EMAIL_ERROR]()
  }
  @Watch('password')
  onPasswordChange() {
    this.$v.password.$touch()
  }
  @Watch('repeatPassword')
  onRepeatPassword() {
    this.$v.repeatPassword.$touch()
  }
  created() {
    const prefillEmail = this.$route.query.email
    if (prefillEmail) {
      this.email = prefillEmail.toString().trim()
    }
  }
  mounted() {
    this.$nextTick(() => {
      this.$v.$reset()
    })
    return (this as any)[RESET_EMAIL_ERROR]()
  }
  get enableRecaptcha(): boolean {
    return (process.env.VUE_APP_ENABLE_RECAPTCHA === 'true') as boolean
  }
  get emailFieldLimit(): number {
    return EMAIL_FIELD_LIMIT
  }
  get passwordFieldLimit(): number {
    return PASSWORD_FIELD_LIMIT
  }
  get emailError(): string {
    const { email: emailError } = this.$v
    if ((this as any)[EMAIL_SERVER_ERROR]) {
      return (this as any)[EMAIL_SERVER_ERROR]
    }
    if (emailError.$error) {
      if (!emailError.required) {
        return translate('', 'error-email-required')
      } else if (!emailError.email) {
        return translate('', 'error-email-invalid')
      }
    }
    return ''
  }
  get showLoginPrompt(): boolean {
    return (this as any)[EMAIL_SERVER_ERROR] === userWithEmailExist
  }
  get passwordError(): string {
    const { password } = this.$v
    if (password.$error) {
      if (!password.required) {
        return translate('', 'error-password-required')
      }
      if (!password.minLength) {
        return translate('', 'error-password-min-length')
      }
      if (!password.passwordPattern) {
        return translate('', 'error-password-wrong-pattern')
      }
    }
    return ''
  }
  get repeatPasswordError(): string {
    const { repeatPassword } = this.$v
    if (repeatPassword.$error) {
      if (!repeatPassword.required) {
        return translate('', 'error-password-required')
      }
      if (!repeatPassword.sameAsPassword) {
        return translate('', 'error-password-mismatch')
      }
    }
    return ''
  }
  get isEmailError(): boolean {
    return this.emailError !== ''
  }
  get formError(): boolean {
    return this.$v.$invalid || this.isEmailError
  }
  async onRecaptchaVerify(verificationCipher: string) {
    this.recaptchaVisible = false
    this.registerAccount('email', verificationCipher)
  }
  requestRegisterAccount() {
    if (this.isSubmitting) return
    this.isSubmitting = true
    if (this.enableRecaptcha) {
      this.recaptchaVisible = true
    } else {
      this.registerAccount('email', '')
    }
  }
  async registerAccount(provider: string, verificationCipher: string) {
    this.$v.$touch()
    if (this.formError) {
      this.isSubmitting = false
      return
    }
    try {
      const payload = {
        email: this.email,
        password: this.password,
        provider: provider,
        // eslint-disable-next-line @typescript-eslint/camelcase
        verification_cipher: verificationCipher,
        challenge: this.$route?.query?.challenge
      }
      await (this as any)[REGISTER](payload)
    } finally {
      this.isSubmitting = false
    }
  }
  async socialLogin(socialType: string) {
    const challenge = this.$route?.query?.challenge as string
    const payload: SocialLoginPayload = {
      provider: socialType,
      challenge: challenge as string,
      email: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      redirect_url: '',
      action: '',
      // eslint-disable-next-line @typescript-eslint/camelcase
      access_token: ''
    }
    ;(this as any)[REQUEST_SOCIAL_LOGIN](payload)
  }
  goToLogin() {
    this.$router.push({ path: '/login', query: { email: this.email, ...this.$route?.query } })
  }
}
